export default {
  data() {
    return {
      websocket: null, // WebSocket实例
      globalData: {
        webSocketLink: false,
        ipw: 'wss://scan.turingene.com/webws', //自己的服务器网址
        // ipw: 'ws://192.168.2.49:10009/', 
        // ipw: ' ws://192.168.2.124:10066/webws', 
        // ipw: process.env.WEB_SOCKET_URL, //自己的服务器网址
        limit: 0,
        heartTimeout: 5000, //ms  CONNECT后改为服务器传过来的数值
        serverTimeout: 300000, //ms 5分钟。 未收到心跳回应后多久断开websocket，并重连。 CONNECT后改为服务器传过来的数值
        heartTimeoutObj: null,
        serverTimeoutObj: null,
        tempId: '',
        isHide: false,
        isSocketReconnect: false,
        reconnectTime: [1000, 1000, 5000, 5000, 5000, 10000, 10000, 30000, 60000, 60000], // 10个
        callback: function () {},
      },

    };
  },

  mounted() {
    // 外部在凭证就绪后显式调用 linkSocket，这里不自动连接
    console.log("websocket mixin mounted");
    // this.ipw = process.env.WEB_SOCKET_URL
    this.globalData.tempId = localStorage.getItem('tempId') || '';
    this.globalData.nonce = localStorage.getItem('nonce') || '';
    this.globalData.expire = localStorage.getItem('expire') || '';
    this.globalData.sign = localStorage.getItem('sign') || '';
  },

  methods: {
    //  建立websocket连接
    //  现在连接地址只使用 userId，不再拼接 phone、token、platform
    linkSocket(tempId,nonce,expire,sign) {
      this.globalData.tempId = tempId;
      this.globalData.nonce = nonce;
      this.globalData.expire = expire;
      this.globalData.sign = sign;
      console.log("url：", this.globalData.ipw +'?tempId=' + tempId +  '&nonce=' + nonce + '&expire=' + expire + '&sign=' + sign);
      this.websocket = new WebSocket(this.globalData.ipw +'?tempId=' + tempId +  '&nonce=' + nonce + '&expire=' + expire + '&sign=' + sign);
      this.initEventHandle();
    },

    //  绑定事件
    initEventHandle() {
      console.log("触发绑定事件")
      this.websocket.onmessage = (res) => {
        let result = JSON.parse(res.data);
        //  接收消息，根据不同的event进行不同的操作
        if (result.event === 'CONNECT') {
          console.log('CONNECT', result)
          this.globalData.heartTimeout = result.content.ping_interval;
          this.globalData.serverTimeout = result.content.ping_timeout;
        } else if (result.event === 'HEART_BEAT') {
          if (result.content === 'pong') {
            this.reset();
            this.start();
            console.log("pong")
          }
        } else {
          this.globalData.callback(res);
        }
      }
      // 监听WebSocket打开事件
      this.websocket.onopen = () => {
        console.log('WebSocket连接已打开');
        this.reset();
        this.start();
        this.globalData.webSocketLink = true
        this.globalData.limit = 0;
      };
      // 监听WebSocket错误事件
      this.websocket.onerror = (error) => {
        console.error('WebSocket发生错误:', error);
        this.continueConnect();
        this.globalData.webSocketLink = false
      };
      // 监听WebSocket关闭事件
      this.websocket.onclose = () => {
        console.log('WebSocket连接已关闭');
        this.globalData.webSocketLink = false
        if (!this.globalData.isHide) {
          this.reconnect();
        }
      };
    },

    //重新连接
    continueConnect() {
      if (this.globalData.limit < 10) {
        //连接10次后不再重新连接
        this.timer = setTimeout(() => {
          this.linkSocket(this.globalData.tempId,this.globalData.nonce,this.globalData.expire,this.globalData.sign);
          console.log('次数:' + this.globalData.limit);
        }, this.globalData.reconnectTime[this.globalData.limit]); //每隔5秒连接一次
        this.globalData.limit = this.globalData.limit + 1;
      }
    },
    reconnect() {
      this.globalData.limit = 0
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.linkSocket(this.globalData.tempId,this.globalData.nonce,this.globalData.expire,this.globalData.sign);
        console.log('次数:' + this.globalData.limit);
      }, this.globalData.reconnectTime[this.globalData.limit]); //每隔5秒连接一次
      this.globalData.limit = this.globalData.limit + 1;
    },

    //心跳包开始
    reset: function () {
      clearTimeout(this.globalData.heartTimeoutObj);
      clearTimeout(this.globalData.serverTimeoutObj);
      return this;
    },

    start: function () {
      let msg = {
        event: 'HEART_BEAT',
        content: 'ping',
        userDevice: "pc"
      };

      this.globalData.heartTimeoutObj = setTimeout(() => {
        // 发送消息
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.send(JSON.stringify(msg));
        } else {
          console.log('WebSocket连接未打开');
        }

        this.globalData.serverTimeoutObj = setTimeout(() => {
          this.websocket.close();
          this.globalData.webSocketLink = false;
          this.reconnect();
        }, this.globalData.serverTimeout);
      }, this.globalData.heartTimeout);
    },

    //  测试
    send(msg) {
      // 发送消息
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        this.websocket.send(msg);
      } else {
        console.log('sendMessage WebSocket连接未打开');
      }
    },
  },


  beforeDestroy() {
    // 组件销毁前清理定时器和关闭WebSocket连接
    this.globalData.isHide = true
    if (this.websocket) {
      this.websocket.close();
    }
  }
};
